import React from 'react'
import { components } from 'cng-web-lib'
import { Grid, Tooltip } from '@material-ui/core'
import ContainerInfoFormProperties from './ContainerInfoFormProperties'

const {
  button: { CngIconButton }
} = components

const { initialValues } = ContainerInfoFormProperties.formikProps

function ContainerInfoEntry(props) {
  const {
    index,
    isLast,
    onAddContainer,
    onDeleteContainer,
    containerDTO,
    showNotification,
    shouldHideMap
  } = props

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md>
        <ContainerInfoFormProperties.Fields index={index} showNotification={showNotification} shouldHideMap={shouldHideMap} />
      </Grid>
      <Grid item xs={12} md='auto'>
        <Grid container spacing={1}>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Add new'>
              <span>
                <CngIconButton
                  icon={['fal', 'plus']}
                  onClick={() => onAddContainer(initialValues)}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Clone'>
              <span>
                <CngIconButton
                  icon={['fal', 'copy']}
                  onClick={() => onAddContainer({ ...containerDTO, id: undefined })}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          {!isLast && (
            <Grid item xs='auto'>
              <Tooltip placement='bottom' title='Delete'>
                <span>
                  <CngIconButton
                    icon={['fal', 'trash']}
                    onClick={() => onDeleteContainer(containerDTO)}
                    size='small'
                    type='outlined'
                  />
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ContainerInfoEntry
